import { defineComponent as _defineComponent } from 'vue';
import { createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { computed } from "vue";
import RewardSupplierSelector from "./RewardSupplierSelector.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'RewardSupplierIdComponentVariableRawValue',
    props: {
        modelValue: {}
    },
    emits: ["update:modelValue"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const isString = (value) => {
            return typeof value === "string";
        };
        const valueProxy = computed({
            get() {
                return isString(props.modelValue) ? props.modelValue : null;
            },
            set(value) {
                emit("update:modelValue", value);
            },
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createCommentVNode(" Need this outer div to prevent ComponentVaribleValueInput props from colliding with TagSet props "),
                _createElementVNode("div", null, [
                    _createVNode(RewardSupplierSelector, {
                        rewardSupplierId: valueProxy.value,
                        "onUpdate:rewardSupplierId": _cache[0] || (_cache[0] = ($event) => ((valueProxy).value = $event)),
                        disabled: false
                    }, null, 8 /* PROPS */, ["rewardSupplierId"])
                ])
            ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */));
        };
    }
});
